import { render, staticRenderFns } from "./BattleStatusPanel.vue?vue&type=template&id=7bb72c84&"
import script from "./BattleStatusPanel.vue?vue&type=script&lang=js&"
export * from "./BattleStatusPanel.vue?vue&type=script&lang=js&"
import style0 from "./BattleStatusPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports